<div class="tw-w-full tw-h-fit tw-border tw-border-grey-600 tw-rounded-[5px] tw-overflow-hidden">
  <div class="tw-overflow-x-auto">
    <p-table
      [value]="items"
      [lazy]="true"
      (onLazyLoad)="onLazyLoad($event)"
      [paginator]="true"
      [rows]="pageSize"
      [first]="(page - 1) * pageSize"
      [totalRecords]="totalRecords"
      [loading]="loading"
      [tableStyle]="{ 'min-width': '50rem' }"
    >
      <ng-template pTemplate="header">
        <tr>
          <th *ngFor="let col of columns" class="tw-font-poppins tw-font-bold tw-text-sm tw-text-secondary tw-whitespace-nowrap tw-px-4 tw-py-3">
            {{ col.header | translate }}
          </th>
          <th class="tw-font-poppins tw-font-bold tw-text-sm tw-text-secondary tw-whitespace-nowrap tw-px-4 tw-py-3"></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item>
        <tr class="tw-border-b tw-border-grey-600">
          <td *ngFor="let col of columns" class="tw-font-poppins tw-font-normal tw-text-sm tw-text-secondary tw-whitespace-nowrap tw-px-4 tw-py-3">
            <ng-container *ngIf="!col.type || col.type == 'text'">
              {{ item[col.field] }}
            </ng-container>
            <ng-container *ngIf="col.type == 'color'">
              <div class="tw-w-5 tw-h-5 tw-rounded-sm" [style.background-color]="item[col.field]"></div>
            </ng-container>
            <ng-container *ngIf="col.type == 'image'">
              <div class="tw-w-10 tw-h-10 tw-rounded-sm tw-overflow-hidden tw-bg-secondary tw-flex tw-justify-center tw-items-center">
                <img *ngIf="item[col.field]" class="tw-w-full tw-h-full tw-object-cover" [src]="item[col.field]" />
                <svg *ngIf="!item[col.field]" class="tw-w-5 tw-h-5 tw-fill-primary/70" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M1.5 6a2.25 2.25 0 0 1 2.25-2.25h16.5A2.25 2.25 0 0 1 22.5 6v12a2.25 2.25 0 0 1-2.25 2.25H3.75A2.25 2.25 0 0 1 1.5 18V6ZM3 16.06V18c0 .414.336.75.75.75h16.5A.75.75 0 0 0 21 18v-1.94l-2.69-2.689a1.5 1.5 0 0 0-2.12 0l-.88.879.97.97a.75.75 0 1 1-1.06 1.06l-5.16-5.159a1.5 1.5 0 0 0-2.12 0L3 16.061Zm10.125-7.81a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0Z"
                  />
                </svg>
              </div>
            </ng-container>
          </td>
          <td class="tw-px-4 tw-py-3">
            <div class="tw-flex tw-gap-2 tw-justify-end tw-min-w-fit">
              <div class="table-icon-container" (click)="editFunction(item)">
                <img class="table-icon" src="../../../../assets/table-edit-icon.svg" />
                <img class="table-icon-hover" src="../../../../assets/table-edit-hover-icon.svg" />
              </div>
              <div class="table-icon-container" (click)="deleteFunction(item.id)">
                <img class="table-icon" src="../../../../assets/table-delete-icon.svg" />
                <img class="table-icon-hover" src="../../../../assets/table-delete-hover-icon.svg" />
              </div>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="100%" class="tw-w-fit tw-h-fit tw-font-poppins tw-text-medium tw-text-sm tw-text-center tw-text-secondary tw-py-10">
            {{ emptyMessage | translate }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
